import { loginByMobile, logout, getCurrentUser, refreshToken } from '@/api/user'
import { getToken, setToken, removeToken, getRefreshToken, setRefreshToken, getUserInfo, setUserInfo,removeUserInfo, removeRefreshToken } from '@/util/auth'
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  refresh_token: getRefreshToken(),
  userInfo:getUserInfo()
}

const getters = {

  getToken: () => {
    return state.token;
  },
  getRefreshToken: () => {
    return state.refresh_token;
  },
  getUserInfo: () => {
    return state.userInfo
  }
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
    setUserInfo(userInfo);
  }
}

const actions = {
  // user login
  loginByMobile({ commit }, userInfo) {
    //const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      loginByMobile(userInfo,{"Authorization": process.env.authorBasic}).then(response => {
        const { access_token, refresh_token } = response
        commit('SET_TOKEN', access_token)
        setRefreshToken(refresh_token)
        console.log(11111111);
        getCurrentUser().then(response => {
          commit('SET_USERINFO', response)
          resolve();
          //待完善,如果是从某个页面进来登录应该回到某个页面
          // router.push({
          //   name: 'home'
          // }); 
          window.location.href="/newhome/home"
        });
        
        
      }).catch(error => {
        reject(error)
      })
    })
  },
  refreshToken({ commit, state }) {
    refreshToken(getters.getRefreshToken);
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', null)
        removeToken()
        removeUserInfo()
        resolve()
        window.location.href="/newhome/home"
      }).catch(error => {
        reject(error)
      })
    })
  },
  logoutNoRefresh({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', null)
        removeToken()
        removeUserInfo()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js